import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { STATUSES } from '@/const/status'

export default {
  namespaced: true,
  state: {
    criteria: [],
    totalRows: 0,
    statuses: STATUSES,
  },
  getters: {
    criteria: state => state.criteria,
    totalRows: state => state.totalRows,
    statuses: state => state.statuses,
  },
  mutations: {
    SET_CRITERIA: (state, data) => { state.criteria = data },
  },
  actions: {
    async getCriteria({ commit }, params) {
      try {
        const response = await axios.get('/admissions/criteria', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_CRITERIA', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createCriteria({ commit }, params) {
      try {
        const response = await axios.post('/admissions/criteria', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateCriteria({ commit }, params) {
      try {
        const response = await axios.put(`/admissions/criteria/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteCriteria({ commit }, id) {
      try {
        const response = await axios.delete(`/admissions/criteria/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
